import Locale from "./Locale";
export default function AppError({ error }) {
  if (!error) return <></>;
  return (
    <div className="border px-4 py-2 rounded-md border-red-400 flex items-center justify-center text-red-500">
      <Locale code={error} />
    </div>
  );
}
